var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualiseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.5 52.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#0f2a75;stroke-width:3px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-3{fill:#0f2a75;}.cls-2{fill:#ff6c00;stroke:#ff6c00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.59,23.08c-.91,.92-1.8,1.8-2.69,2.69-1.57,1.57-3.14,3.14-4.71,4.71-.14,.14-.27,.28-.43,.38-.42,.27-.93,.2-1.28-.15-.34-.35-.39-.87-.11-1.28,.1-.14,.23-.27,.35-.39,2.59-2.59,5.18-5.19,7.78-7.78,.65-.65,1-.69,1.77-.18,1.7,1.13,3.4,2.26,5.14,3.42,.14-.16,.27-.32,.4-.48,2.36-2.95,4.72-5.9,7.08-8.85,.28-.35,.59-.65,1.08-.6,.84,.08,1.2,1,.66,1.71-.5,.65-1.02,1.28-1.53,1.92-2.15,2.69-4.3,5.37-6.45,8.06-.62,.78-1.05,.84-1.89,.28-1.71-1.14-3.42-2.28-5.18-3.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 6.06,
    width: 48.5,
    height: 33.95,
    rx: 3.32,
    ry: 3.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.78,
    y: 38.2,
    width: 3.03,
    height: 16.37,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(38.74 -.77) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.69,
    y: 38.2,
    width: 3.03,
    height: 16.37,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(-23.66 35.65) rotate(-45)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.24,
    y: 0,
    width: 4.25,
    height: 6.06,
    rx: 2.12,
    ry: 2.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualiseIcon);
export default __webpack_public_path__ + "static/media/visualise-icon.7c0180d7.svg";
export { ForwardRef as ReactComponent };